import OrderHistory from "@/views/admin/order/OrderHistory";

export default {
  path: "orders/history",
  name: "orderHistory",
  component: OrderHistory,
  meta: {
    requiresAuth: true
  }
};
